export default __webpack_public_path__ + "static/media/12.3314c7cc.png";